<template>
  <div>
    <div class="p-3 search-box-promo" v-if="search.showSearch">
      <div class="wrap">
        <h3 class="medium">Kiểm tra Khuyến Mãi Theo ĐVCNTT</h3>
        <div class="description">
          Nhập <span class="text-success">email</span> hoặc <span class="text-success">số điện thoại</span> của ĐVCNTT để kiểm tra khuyến mãi đang áp dụng.(<a href="/promotion/check">kiểm tra ngay</a>)
        </div>
        <div class="row g-2">
          <div class="col-6">
            <div class="form-floating mt-2">
              <input type="text" placeholder="Email" class="form-control" v-model="search.email" @input="search.email = search.email.trim()">
              <label>Email</label>
              <a class="close-text" v-if="search.email" @click="search.email = ''">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating mt-2">
              <input type="tel" placeholder="Điện thoại" class="form-control" v-model="search.phone"  pattern="[0-9]*" inputmode="numeric" @input="search.phone = search.phone.replace(/[^0-9]/g, '').trim()">
              <label>Điện thoại</label>
              <a class="close-text" v-if="search.phone" @click="search.phone = ''">
                <img src="@/assets/images/close-text.svg">
              </a>
            </div>
          </div>
        </div>
        <div class="mt-4 text-message text-italic text-red" v-if="search.message">{{ search.message }}</div>
        <a class="btn btn-danger w-100 mt-3"  @click="btnCheckPromo">Kiểm tra</a>
      </div>
    </div>
    <div class="p-3">
      <div class="d-grid gap-3" v-if="dataBudget.length > 0">
        <div class="bg-white rounded shadow-sm cursor-pointer promotion-detail" v-for="(item, index) in dataBudget" :key="index">
            <div class="position-relative" v-if="item.link_banner">
                <a href="#"><img :src="item.link_banner" alt="Promotion Banner" class="w-100" style="width:100%; object-fit: cover; border-top-left-radius: 4px; border-top-right-radius: 4px; cursor: zoom-in;"></a>
            </div>
            <div class="p-4">
                <h2 class="fs-4 fw-semibold mb-2">{{item.promotion_name}}</h2>
                <span class="status-badge status-active d-inline-block mb-4" v-if="getStatus(item.start_date, item.end_date) === 'ACTIVE'">Đang diễn ra</span>
                <span class="status-badge status-ended d-inline-block mb-4" v-if="getStatus(item.start_date, item.end_date) === 'ENDED'">Đã kết thúc</span>
                <span class="status-badge status-upcoming d-inline-block mb-4" v-if="getStatus(item.start_date, item.end_date) === 'UPCOMING'">Chưa diễn ra</span>
                <div class="mb-4">
                    <h3 class="text-secondary small mb-1">Thời gian hiệu lực</h3>
                    <p class="mb-0 fw-medium promotion-period">{{item.start_date | formatIntToDateV2}} - {{item.end_date|formatIntToDateV2}}</p>
                </div>
                <div class="mt-4">
                    <h3 class="text-secondary small mb-1">Tổng ngân sách</h3>
                    <p id="totalBudget" class="fs-5 fw-bold mb-3">{{formatNum(item.merchant_budgets)}} đ</p>
                    <div class="budget-progress mb-4">
                        <div id="budgetProgressBar" class="budget-progress-bar" :style="{ width: getBudgetPercent(item.merchant_budgets_used, item.merchant_budgets) + '%' }"></div>
                    </div>
                    <div class="row g-4">
                        <div class="col-6">
                            <h3 class="text-secondary small mb-1">Đã sử dụng</h3>
                            <p id="usedBudget" class="small fw-medium text-warning mb-0">{{formatNum(item.merchant_budgets_used)}} đ</p>
                        </div>
                        <div class="col-6">
                            <h3 class="text-secondary small mb-1">Còn lại</h3>
                            <p id="remainingBudget" class="small fw-medium text-success mb-0">{{formatNum(item.merchant_budgets-item.merchant_budgets_used)}} đ</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <section v-if="loading" class="ftco-section login-wap position-relative BE-regular ftco-section-loading">
          <div class="d-block text-center" style="margin-top:30vh">
            <div class="spinner-border text-danger" role="status">
                <span class="visually-hidden">{{ $t('text_31') }}</span>
            </div>
            <h3 class="d-block mt-3">{{ $t('text_31') }}</h3>
          </div>
        </section>
  </div>
</template>
<script>
import { PromotionService } from '@/services/promotion.service.js'

export default {
  name: 'index',
  data: () => {
    return {
      params: { merchant_id: '', page: 1, items_per_page: 20, languageCode: 'vie' },
      merchantId: '',
      loading: false,
      error: '',
      dataBudget: {},
      dataPromo: {},
      search: { email: '', phone: '', showSearch: true, message: '' }
      
    }
  },
  async created () {
    this.loading = true
    await this.decodeURI()
    await this.getPromoMerchant()
    await this.getBudgetMerchant()
    await this.mergeLinkBannerToBudget()
    this.loading = false
  },
  methods: {
    formatNum (val) {
      if (val <= 0) {
        return val
      }
      val = val.toString().split('.').join('')
      let output = ''
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length)
        val = val.slice(0, val.length - 3)
        output = '.' + last3Digits + output
      }
      if (val.length === 0) {
        output = output.slice(1, output.length)
      } else {
        output = val + output
      }
      return output
    },
    async decodeURI () {
      // const base64_encode = btoa('merchantId=1801')
      // https://domain.com/promotion/budget?params=bWVyY2hhbnRJZD0xODAx
      let params = (this.$route.query.params) ? this.$route.query.params : ''
      if (params !== '') {
        params = atob(params)
        params = params.split('&')
        if (params.length > 0) {
          params.forEach((item) => {
            if (item !== '') {
              const itemVal = item.split('=')
              if (itemVal.length === 2) {
                if (itemVal[0] === 'merchantId') {
                  this.merchantId = itemVal[1]
                  this.search.showSearch = false
                }
              }
            }
          })
        }
      }
    },
    getStatus (start_date_unix, end_date_unix) {
      const now = Date.now()
      const start = start_date_unix * 1000
      const end = end_date_unix * 1000

      if (now < start) {
        return 'UPCOMING'
      } else if (now >= start && now <= end) {
        return 'ACTIVE'
      } else {
        return 'ENDED'
      }
    },
    getBudgetPercent (used, total) {
      if (!total || total === 0) return 0
      const percent = (used / total) * 100
      return Math.min(percent.toFixed(2), 100)
    },
    async getBudgetMerchant () {
      if (this.merchantId !== '' && this.merchantId !== undefined) {
        this.params.merchant_id = this.merchantId
        const dataRes = await PromotionService.GetBudgetMerchant(this.params)
        if (dataRes.errorCode === '00') {
          const listData = dataRes?.data?.List?.Data
          if (Array.isArray(listData)) {
            this.dataBudget = listData
          }
        }
      }
    },
    async getPromoMerchant () {
      if (this.merchantId !== '' && this.merchantId !== undefined) {
        const params = { merchantId: this.merchantId }
        const dataRes = await PromotionService.GetPromoMerchant(params)
        if (dataRes.errorCode === '00') {
          const listData = dataRes?.data
          if (Array.isArray(listData)) {
            this.dataPromo = listData
          }
        }
      }
    },
    async mergeLinkBannerToBudget () {
      if (this.dataPromo.length && this.dataBudget.length) {
        this.dataBudget = this.dataBudget
          .filter(item => {
            return this.dataPromo.some(p => p.id === item.promotion_id)
          })
          .map(item => {
            const promo = this.dataPromo.find(p => p.id === item.promotion_id)
            return {
              ...item,
              link_banner: promo ? promo.linkBanner : ''
            }
          })
      }
    },
    validateEmail () {
      if (!this.search.email) {
        this.search.message = 'Vui lòng nhập email!'
        return false
      }
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!regex.test(this.search.email)) {
        this.search.message = 'Email không hợp lệ!'
        return false
      }
      this.search.message = ''
      return true
    },
    async btnCheckPromo () {
      if (this.search.showSearch) {
        try {
          this.dataBudget = []
          if (this.search.email !== '') {
            if (!this.validateEmail()) {
              return false
            }
          }
          if (this.search.email !== '' || this.search.phone !== '') {
            this.loading = true
            const params = { email: this.search.email, phone_number: this.search.phone, items_per_page: 1, page: 1 }
            const response = await PromotionService.getMerchantPromo(params)
            if (response.errorCode === '00') {
              const mc_id = response?.data?.data?.List?.data?.[0]?.mc_id
              if (mc_id !== undefined) {
                this.merchantId = String(mc_id)
                await this.getPromoMerchant()
                await this.getBudgetMerchant()
                await this.mergeLinkBannerToBudget()
              } else {
                this.search.message = 'Không tồn tại!'
              }
            }
          } else {
            this.search.message = 'Nhập Email MC hoặc Số điện thoại MC'
          }
          this.loading = false
        } catch (error) {
          this.search.message = 'Có lỗi xảy ra. Vui lòng thử lại sau!'
        }
      }
    }
  }
}
</script>
<style>
body{background-color:#E9E9EA!important}.promotion-period{font-size:16px}.small,small{font-size:14px!important}b{font-weight:400;font-family:"BeVietnamPro-SemiBold"!important}.fw-bold,.fw-semibold{font-weight:400;font-family:"BeVietnamPro-SemiBold"!important}.promotion-item{transition:all 0.3s ease}.promotion-item:active{background-color:#f0f0f0}.budget-progress{height:8px;border-radius:4px;overflow:hidden;background-color:#f0f0f0}.budget-progress-bar{height:100%;border-radius:4px;background-color:#D22E2A}.btn-primary{background-color:#D22E2A;border-color:#D22E2A}.btn-primary:hover{background-color:#b82824;border-color:#b82824}.status-badge{padding:.25rem .75rem;font-size:.75rem;font-weight:500;border-radius:9999px}.status-active{color:#16a34a;background-color:#f0fdf4;border:1px solid #bbf7d0}.status-ended{color:#dc2626;background-color:#fef2f2;border:1px solid #fecaca}.status-upcoming{color:#3f3f3f;background-color:#ffc107;border:1px solid #ffc107}.search-box-promo{background:#fff;overflow:hidden;border-bottom:1px solid #ddd}.search-box-promo .medium{font-size:20px;margin-bottom:16px}.search-box-promo .description{font-size:16px;color:#6c757d;width:100%;display:inline-block}.search-box-promo .btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545;padding:.5rem .8rem}.search-box-promo .form-control:focus{outline:0!important;box-shadow:none!important;border:1px solid #ddd!important}.text-red{color:#ff0000}.text-italic{font-style:italic}
</style>
